import React from 'react';
import PropTypes from 'prop-types';
import CustomStep from 'workOrderComponents/close/CustomStep';
import TruckRollPanel from 'truckRollComponents/TruckRollPanel';

class TruckRollCloseStep extends React.Component {

    render() {
        const {
            workOrderActions,
            chargeActions,
            orderId,
            accountNumber,
            user,
            truckRoll,
            index,
            orderCloseDetails,
            orderStatus,
            stepConfig          
        } = this.props;
  
        const stepValidation = orderCloseDetails.getIn(['stepValidation']);
        const activeStep = orderCloseDetails.get('currentStep');
        const submitMessage = orderCloseDetails.getIn(['truckRoll', 'submitMessage']);
        const submitSuccess = orderCloseDetails.getIn(['truckRoll', 'submitSuccess']);
        const submitPending = orderCloseDetails.getIn(['truckRoll', 'submitPending']);
        const submitAttempted = orderCloseDetails.getIn(['truckRoll', 'submitAttempted']);
      
        const label = (
            <div style={{
                width: '100%'
            }}>
                <div>Truck Roll</div>
            </div>
        );

        return (

            <CustomStep
                onStepClick={workOrderActions.setCloseStep}
                label={label}
                stepConfig={stepConfig}
                stepConfigKey="truckRollStepConfig"
                index={index}
                activeStep={activeStep}
                orderId={orderId}
                stepValidation={stepValidation}
                stepKey="truckRoll">
                <div style={{
                    position: 'relative'
                }}>            

                    <TruckRollPanel
                        paddingLeft="0"
                        paddingRight="0"
                        key="truckRoll_panel"
                        header="Truck Roll"
                        detailKey="truckRoll"
                        user={user}
                        accountNumber={accountNumber}
                        orderStatus={orderStatus}
                        orderId={orderId}
                        truckRollOptionDetails={truckRoll}
                        chargeActions={chargeActions}
                        workOrderActions={workOrderActions}
                        orderCloseDetails={orderCloseDetails}
                        submitMessage={submitMessage}
                        submitSuccess={submitSuccess}
                        submitPending={submitPending}
                        submitAttempted={submitAttempted}/>
                </div>

            </CustomStep>

        );

    }
}

TruckRollCloseStep.propTypes = {
    workOrderActions: PropTypes.object,
    chargeActions: PropTypes.object,
    orderCloseDetails: PropTypes.object,
    orderId: PropTypes.string,
    accountNumber: PropTypes.string,
    user: PropTypes.object,
    truckRoll: PropTypes.object,
    index: PropTypes.number,
    orderStatus: PropTypes.object,
    stepConfig: PropTypes.object
};

export default TruckRollCloseStep;


// WEBPACK FOOTER //
// ./src/components/truck-roll/TruckRollCloseStep.js